<div class="container">
  <div class="a-footer content has-text-centered">
    <div class="font-weight-medium">{{ supportContent }}</div>
    <div>{{ footerContent }}</div>
  </div>
</div>
